var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticClass:"force-mobile",class:{ landscape: _vm.landscape },style:({ transform: _vm.transform, 'transform-origin': _vm.transformOrigin })},[_c('top-bar'),_c('div',{staticClass:"pa-2 fill-height"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }